<template>
  <v-footer color="white" padless app>
    <v-bottom-navigation color="primary" grow>
      <v-btn @click="home">
        <span>Home</span>

        <v-icon>mdi-home-outline</v-icon>
      </v-btn>

      <v-btn @click="openAttendanceDialog">
        <span>Attendance</span>

        <v-icon>mdi-account-school-outline</v-icon>
      </v-btn>

      <v-btn @click="openReport">
        <span>Report</span>

        <v-icon>mdi-chart-box-outline</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <!-- <v-card tile outlined width="100%">
          <v-card-text>
            <v-btn block rounded color="success" @click="openAttendanceDialog">Take Attendance</v-btn>
          </v-card-text>
        </v-card> -->

  </v-footer>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters("teacherLayout", ["getNavigation", "getClassRoom", "getTeacherStore"]),
    // navigationStatus: {
    //   get() {
    //     return this.getNavigation
    //   },
    //   set(val) {
    //     this.setNavigation(val)
    //   }
    // },
    selectedClassRoom: {
      get() {
        return this.getClassRoom
      },
      set(val) {
        this.setClassRoom(val)
      }
    },
    Teacher: {
      get() {
        return this.getTeacherStore
      },
      set(val) {
        this.setTeacher(val)
      }
    },
  },
  methods: {
    ...mapActions("teacherLayout", ['setClassRoom', 'setTeacher', 'setNavigation']),
    openAttendanceDialog() {
      this.$router.push({ name: `class-room-attendance`});
    },
    openReport() {
      this.$router.push({ path: '/t/report' })
    },
    home() {
      // console.log('this', this.$route.name)
      if (this.$route.name !== 'thome') {
        this.$router.push({ path: '/t' })
      }

    },
  }
}
</script>

<style scoped>
</style>